module.exports = __webpack_public_path__ + "static/media/create_reservation_home_filled.8937b4c4.jpg";